import React, { useState, useEffect, useContext, useRef } from 'react';
import { USBGrid, USBColumn, USBSelect, USBButton } from '@usb-shield/components-react';
import { endpoints } from '../../../../config/connections';
import USBBreadcrumb from '@usb-shield/components-react/dist/cjs/breadcrumb';
import Loader from '../../../components/utilities/Loader';
import '@usb-shield/react-forms-base/dist/library/styles/index.css';
import './customerAccess-report.css';
import callApi from '../../../components/utilities/callApi';
import useUserRole from '../../../components/Hooks/use-UserRole';
import _noaccess from '../../../pages/_noaccess'
import {downloadReport} from '../../../components/utilities/Utils';
import { ShieldTable } from '../../../components/shared/Table';
import * as XLSX from '@e965/xlsx';
import { PermissionRoleContext } from '../../../components/Hooks/usePermissionRoles';
import { format } from 'date-fns';
import Select from 'react-select'
const CompanyAccessReport = () => {
  const [fullStatusData, setFullStatusData] = useState([]);
  const [vendorCompanyNameList, setVendorCompanyNameList] = useState([]);
  const [customerAccessList, setCustomerAccessList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState([]);
  const [selections, setSelections] = useState('');
  const [statusSelections, setStatusSelections] = useState('');
  const [selectedParentCompanyOption, setSelectedParentCompanyOption] = useState(null);
  const [selectedStatusOption, setSelectedStatusOption] = useState(null);
  const [vendorStatusList, setVendorStatusList] = useState([]);
  const { permissionDetails } = useContext(PermissionRoleContext);
  const isMountedRef = useRef(true);

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '-';
      return date.toLocaleString('en-US', { timeZone: 'UTC' });
    } catch {
      return '-';
    }
  };
 
  const getFilterData = async() => {
    setLoading(true);
    const url = `${endpoints.apigee}/document-management/coreservice/user-management/v1/getParentCompanies`;
    try{
      const response= await callApi.getApiData(url);
      if(response && isMountedRef.current){
        setResponseData(response?.data);
        filterResponse(response?.data);
      }
    }catch{
      if (isMountedRef.current) {
        setLoading(false);
      }
    }
  };
  const getAllReportData = async () => {
    
    const urlAllData = `${endpoints.apigee}/document-management/coreservice/user-management/v1/customer/access/report/all`;
  
    const response = await callApi.getApiData(urlAllData);
  
    const filteredData = response.data
      .filter((item) => Object.values(item).some((x) => x !== null && x !== ''))
      .map((item) => ({
        'External User Name': `${item.firstName || ''} ${item.lastName || ''}`.trim(), // Combine firstName and lastName
        'User Email Address': item.emailAddress,
        'User Role': item?.role || '-', // Add role
        'Last Accessed Date': item.lastLoginTime
          ? new Date(item.lastLoginTime).toLocaleString('en-US', { timeZone: 'UTC' })
          : 'NA',
        'Status': item?.status === 'Active' || item?.lastLoginTime ? 'Active' : 'Pending',
        'Type': item?.userType || '-',
        'Parent Company Name': item?.companyName || '-',
      }));
  
    const filteredDataWithoutEmptyRows = filteredData.filter((item) =>
      Object.values(item).some(
        (x) => x !== null && x !== '' && x !== '-' && x !== 'NA' && x !== 'Pending'
      )
    );
  
    const worksheet = XLSX.utils.json_to_sheet(filteredDataWithoutEmptyRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  
    // Create a Blob from the buffer
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  
    // Create a link element
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute(
      'download',
      `Customer_AccessReport_AllData_${format(new Date(), 'MMM dd, yyyy')}.xlsx`
    );
  
    // Append the link to the body
    document.body.appendChild(link);
  
    // Simulate click
    link.click();
  
    // Remove the link when done
    document.body.removeChild(link);
  };
  
  const getCustomerAccessNames = async (selectionsParam) => {
    const url = `${endpoints.apigee}/document-management/coreservice/user-management/v1/customer/access/report?vendorNumber=${selectionsParam}`;
    try {
      const response = await callApi.getApiData(url);
      if (response && isMountedRef.current) {
        const processedData = response.data.map((item) => ({
          ...item,
          userType: item?.userType || '-',
          companyName: item?.companyName || '-',
          fullName: `${item.firstName || ''} ${item.lastName || ''}`.trim(), // Combine firstName and lastName
        }));
        setCustomerAccessList(processedData);
        setVendorStatusList(formatFilterStatus(processedData));
        setFullStatusData(processedData);
        setLoading(false);
      }
    } catch {
      if (isMountedRef.current) {
        setLoading(false);
      }
    }
  };

  const filterResponse = (response) => {
    if (!isMountedRef.current) return;
    const parentCompanyTemp = [];
    response.forEach((element) => {
      parentCompanyTemp.push(element.vendorName);
    });
    setVendorCompanyNameList(formatFilterData(parentCompanyTemp, 0));
    setLoading(false);
  };

  const onParentCompanyChange = (event, filterName) => {

    const eventValue = event?.value;
      if (event.errorCode != 224) {
      setLoading(true);
      const data = responseData[eventValue]?.vendorNumber;
      const companyname = responseData[eventValue]?.vendorName;
      getCustomerAccessNames(data);
      setSelections(companyname);
      setStatusSelections('')
      setTimeout(() => {
        if (isMountedRef.current) {
          setLoading(false);
        }
      }, 1000);
    }
  };

  const onStatusChange = (event) => {
     const eventValue = event?.value;
    if (event.errorCode != 224) {
    setLoading(true);
    setStatusSelections(eventValue)
    setCustomerAccessList(fullStatusData.filter(obj => obj.status === eventValue || eventValue === 'Select'));
    setLoading(false);
    }
  }


  const formatFilterStatus = (list) => {
    const newStatusData =[{ value: 'Select', label: 'Select' }]
    const uniqueStatusList = list.filter((value, index, self) =>
      index === self.findIndex((item) => (item.status === value.status))
    )
    uniqueStatusList.forEach((element, index) => {
        if(element.status !== ""){
        newStatusData.push({ value: element.status, label: element.status });
        }
      });
    return newStatusData;
  };

  const formatFilterData = (list, indicator) => {
    const newData = [];
    if (indicator == 0) {
      list.forEach((element, index) => {
        if (element!==null && element!==undefined) {
          newData.push({ value: index, label: element }); 
        }
      });
    }
    const sortedData = newData.sort((a, b) =>
      a.label.localeCompare(b.label)
    );
    sortedData.unshift({ value: '', label: 'Select' });
    return sortedData;
  };

  useEffect(() => {
    isMountedRef.current = true;
    getFilterData();
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  
  const tempUserRole = useUserRole();

  // Table column configuration with sortable headers
  const columns = [
    {
      headerName: 'External User Name',
      key: 'fullName',
      dataType: 'string',
      sortable: true,
    },
    {
      headerName: 'User Email Address',
      key: 'emailAddress',
      dataType: 'string',
      sortable: true,
    },
    {
      headerName: 'User Role',
      key: 'role',
      dataType: 'string',
      sortable: true,
    },
    {
      headerName: 'Last Accessed Date',
      key: 'lastLoginTime',
      dataType: 'date',
      sortable: true,
      render: (value) => formatDate(value),
    },
    {
      headerName: 'Status',
      key: 'status',
      dataType: 'string',
      sortable: true,
    },
    {
      headerName: 'Type',
      key: 'userType',
      dataType: 'string',
      sortable: true,
    },
    {
      headerName: 'Parent Company Name',
      key: 'companyName',
      dataType: 'string',
      sortable: true,
    },
  ];

  return (
    tempUserRole && tempUserRole!="employee" ? <_noaccess/> :
    <>
      <USBGrid addClasses="content-frame">
        <USBColumn largeSpan={8}>
          <USBBreadcrumb
            id="reports"
            text="Reports"
            breadcrumbs={[
              { id: 1, text: 'Reports', href: '/Reports/CustomerAccessFilter' },
              { id: 2, text: 'Customer Access', href: '' },
            ]}
          />
        </USBColumn>
        <USBColumn largeSpan={8}></USBColumn>
      </USBGrid>
      <USBGrid addClasses="content-frame content-bg-customer-access">
        {loading ? <Loader /> : null}
        <USBColumn largeSpan={16}>
          <div className="report-header-row">
            <h1 className="heading-h1">Report: Customer Access</h1>
            {['tools'].some((item) => permissionDetails?.includes(item)) ? ( 
              <USBButton
                id="downloadReportAll"
                name="downloadReportAll"
                variant="primary"
                handleClick={() => getAllReportData()}
              >
                Download All
              </USBButton>
            ) : null}
          </div>

          <div className="filter-row-customer-access">
            <div className="filter-dropdowns-customer-access">
              <Select onChange={(e) => {
                if (!e) {
                  setSelections('');
                  setSelectedParentCompanyOption(null);
                  setSelectedStatusOption(null);
                  setLoading(true);
                  setVendorCompanyNameList([]);
                  setVendorStatusList([]);
                  setCustomerAccessList([]);
                  getFilterData();
                  setLoading(false);
                  setStatusSelections('');
                } else {
                  setSelectedParentCompanyOption(e);
                  onParentCompanyChange(e, 'vendorNumber');
                }
              }}
               value={selectedParentCompanyOption}
               options={vendorCompanyNameList}
               placeholder="Parent Company"
               name='parentCompanyName'
               isClearable
               isSearchable />
            </div>
            <div className="filter-dropdowns-customer-access">
              {vendorStatusList.length > 0 ? (
                <Select onChange={(e)=>{
                  if(e?.nativeEvent?.type!="blur") {
                    setSelectedStatusOption(e);
                    onStatusChange(e);
                  }
                }} 
                 value={selectedStatusOption}
                 options={vendorStatusList}
                 placeholder="Status"
                 name='statusDropdown'
                 isClearable
                 isSearchable />
              ) : null}
            </div>
            {vendorStatusList.length > 0 ? (
              <USBButton
                id="downloadReport"
                name="downloadReport"
                variant="primary"
                addClasses="filter-action-btn"
                handleClick={() => {
                  const filterSelections = `Filter selections : Parent Company = ${selections} Status = ${statusSelections == "" ? 'All' : statusSelections} ` + '';
                  const columnName = {
                    ' ': 'EXTERNAL USER NAME',
                    '  ': 'USER EMAIL ADDRESS ',
                    '   ': 'USER ROLE ',
                    '    ': 'LAST ACCESSED DATE',
                    '     ': 'STATUS',
                    '      ': 'TYPE',
                    '       ': 'PARENT COMPANY NAME'
                  };
                  const headersFields = [
                    'fullName',
                    'emailAddress',
                    'role',
                    'lastLoginTime',
                    'status',
                    'userType',
                    'companyName'
                  ]
                  downloadReport(customerAccessList,filterSelections,columnName,headersFields, 'Customer Access')}
                }
              >
                Download Report
              </USBButton>
            ) : null}
            {vendorStatusList.length > 0 ? (
              <USBButton
                type="button"
                size="small"
                id="clearFilterCustomerAccess"
                name="clearfilter"
                addClasses="filter-action-btn"
                handleClick={() => {
                  setSelectedParentCompanyOption(null);
                  setSelectedStatusOption(null);
                  setSelections('');
                  setStatusSelections('');
                  setLoading(true);
                  setVendorCompanyNameList([]);
                  setVendorStatusList([]);
                  setCustomerAccessList([]);
                  getFilterData();
                  setLoading(false);
                }}
              >
                Clear filters
              </USBButton>
            ) : null}
          </div>

          {customerAccessList.length > 0 ? (
            <div className="page-content-customer-access">
              <ShieldTable
                data={customerAccessList}
                columns={columns}
                defaultSort={{ key: 'fullName', direction: 'asc' }}
                pagination={{ pageSize: 10 }}
                className="usb-theme"
                emptyMessage="No customer access records found"
              />
            </div>
          ) : (
            null
          )}
        </USBColumn>
      </USBGrid>
    </>
  );
};

export default CompanyAccessReport;
